import PhotoSwipe from './lib/photoswipe.min.js';
import PhotoSwipeUI from './lib/photoswipe-ui-default.min.js';
import './lightbox.js';
import './infinite-scroll.js';
import './theme.js';

// The retained Casper lightbox opens PhotoSwipe when a reader clicks an image.
window.PhotoSwipe = PhotoSwipe;
window.PhotoSwipeUI_Default = PhotoSwipeUI;
